import React, {PureComponent} from "react"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Typography"

interface Props extends InjectIntl {
  message?: string
  searchTerm?: string
}

class NoUsers extends PureComponent<Props> {
  static defaultProps = {
    searchTerm: ""
  }

  getMessage = () => {
    const {searchTerm, formatMessage} = this.props
    const requiredSearchLengthReached = searchTerm?.length === 0 || searchTerm?.length > 2

    if (searchTerm) {
      if (requiredSearchLengthReached) {
        return <H4 small>{formatMessage({id: "admin.components.noUsers.cannotFindUser"}, {searchTerm})}</H4>
      }
      return <H4 small>{formatMessage({id: "admin.components.noUsers.atLeastThreeCharacters"})}</H4>
    }
  }

  render() {
    const {message} = this.props
    return (
      <>
        {this.getMessage()}
        <H4>{this.props.formatMessage({id: message || "admin.components.noUsers.filters"})}</H4>
      </>
    )
  }
}

export default injectIntl(NoUsers)
